import useTranslator from "@pma/hooks/use-translator";

import { DictType } from "@pma/types";
import { Clock } from "lucide-react";
import { Popover, PopoverTrigger, PopoverContent } from "@components/common/popover";
import { Separator } from "@components/common/separator";
import { formatDistance } from "date-fns";
import { he } from "date-fns/locale";
import React from "react";

interface AccumulatedBillAmountsProps {
  bill?: {
    _paid_history?: Array<{
      _bill_number?: number | string
      approved_amount?: number
      _signed_at?: string
    }>
  }
  children?: React.ReactNode
}

const AccumulatedBillAmounts = ({ children, bill }: AccumulatedBillAmountsProps) => {
  const { translate, locale } = useTranslator();

  const isHebrew = locale === "he";
  return (
    <Popover>
      <PopoverTrigger className='flex items-center w-full justify-center cursor-pointer gap-2'>
        <>{children}</>
        <Clock size={14} />
      </PopoverTrigger>

      <PopoverContent className='font-semibold text-center grid'>
        {translate("Accumulation history")}

        <Separator />

        {bill?._paid_history?.map((history: DictType, index: number) => (
          <div className='flex flex-col items-end' key={index}>
            <div className='flex w-full justify-between py-1'>
              <strong>#{history?._bill_number}</strong>

              <span>{Number(history?.approved_amount) || 0}</span>
            </div>
            <small className='text-[10px] text-muted-foreground'>
              {history?._signed_at &&
                formatDistance(new Date(history?._signed_at), new Date(), {
                  locale: isHebrew ? he : undefined,
                  addSuffix: true,
                })}
            </small>
            <Separator />
          </div>
        ))}
      </PopoverContent>
    </Popover>
  );
};

export default AccumulatedBillAmounts;
